// Formats: '%,n', '$,n', '$x,n', 'f,n', 'i,n'
// operations: 'last(a)', prod(a,b), ratio(a,b)
export default {
  "market": {
    'audio': [
      {
        label: 'BREAKTHROUGH & BRANDING',
        rowType: 'h0'
      },
      {
        metric: 1,
        label: 'Total Ad Awareness',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 2,
        label: 'Brand Linkage (based to those aware)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 3,
        label: 'Branded Ad Awareness',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 5,
        label: 'Brand Uniqueness',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'AD REACTION',
        rowType: 'h0'
      },
      {
        metric: 6,
        label: 'Ad Appeal (Ad Likes)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 28,
        label: 'Ad Dislikes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'BRAND OUTCOMES',
        rowType: 'h0'
      },
      {
        metric: 121,
        label: 'Lift to Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 122,
        label: 'Lift to Brand Impression',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'COGNITIVE CONNECTION',
        rowType: 'h0'
      },
      {
        metric: 7,
        label: "Is informative",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 8,
        label: "Tells me something new about the brand",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 10,
        label: 'Is credible coming from this brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'BRAND CONNECTION',
        rowType: 'h0'
      },
      {
        metric: 9,
        label: 'Makes me feel closer to the brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 12,
        label: 'Portrays a brand I want to be associated with',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
      },
      {
        metric: 18,
        label: 'Fulfills my needs',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'ENGAGEMENT',
        rowType: 'h0'
      },
      {
        metric: 14,
        label: 'Is humorous',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 15,
        label: 'Is worth talking about',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 17,
        label: 'Is memorable',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 123,
        label: 'Is attention-getting',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 124,
        label: 'Connects with me emotionally',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'RELEVANCE',
        rowType: 'h0'
      },
      {
        metric: 11,
        label: 'Speaks directly to me',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 13,
        label: 'Is relevant to me ',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 26,
        label: 'Caters to me/my culture',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 27,
        label: 'Cares about my community ',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CONSUMER EXPERIENCE',
        rowType: 'h0'
      },
      {
        metric: 16,
        label: 'Is a good fit with this brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 19,
        label: 'Shows a place where I’d like to shop',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 20,
        label: 'Makes it easy to find what I am looking for',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 22,
        label: 'Provides excellent customer service',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CONSUMER PERCEPTIONS',
        rowType: 'h0'
      },
      {
        metric: 21,
        label: 'Carries high quality products',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 23,
        label: 'Has better prices than the competition',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 24,
        label: 'Carries a large variety of products',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 25,
        label: 'Carries unique products',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CUSTOM KPIs',
        rowType: 'h0'
      },
      {
         metric: 125,
        label: 'Makes me feel that H-E-B is part of your family’s life, not just a grocery store',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 126,
        label: 'Captures the unique spirit of Texas life',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 127,
        label: 'Portrays a family dynamic that feels real and relatable',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 128,
        label: 'Makes me feel proud to shop at a Texas-based brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 129,
        label: 'Makes me want to shop H-E-B over other grocery stores, even if it’s more difficult to get to',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: '',
        rowType: 'eol'
      }
    ],
    '***': [
      {
        label: 'BREAKTHROUGH & BRANDING',
        rowType: 'h0'
      },
      {
        metric: 1,
        label: 'Total Ad Awareness',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 2,
        label: 'Brand Linkage (based to those aware)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 3,
        label: 'Branded Ad Awareness',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 4,
        label: 'Ease of Brand Identification ',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 5,
        label: 'Brand Uniqueness',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'AD REACTION',
        rowType: 'h0'
      },
      {
        metric: 6,
        label: 'Ad Appeal (Ad Likes)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 28,
        label: 'Ad Dislikes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'BRAND OUTCOMES',
        rowType: 'h0'
      },
      {
        metric: 121,
        label: 'Lift to Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 122,
        label: 'Lift to Brand Impression',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'COGNITIVE CONNECTION',
        rowType: 'h0'
      },
      {
        metric: 7,
        label: "Is informative",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 8,
        label: "Tells me something new about the brand",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 10,
        label: 'Is credible coming from this brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'BRAND CONNECTION',
        rowType: 'h0'
      },
      {
        metric: 9,
        label: 'Makes me feel closer to the brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 12,
        label: 'Portrays a brand I want to be associated with',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
      },
      {
        metric: 18,
        label: 'Fulfills my needs',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'ENGAGEMENT',
        rowType: 'h0'
      },
      {
        metric: 14,
        label: 'Is humorous',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 15,
        label: 'Is worth talking about',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 17,
        label: 'Is memorable',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 123,
        label: 'Is attention-getting',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 124,
        label: 'Connects with me emotionally',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'RELEVANCE',
        rowType: 'h0'
      },
      {
        metric: 11,
        label: 'Speaks directly to me',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 13,
        label: 'Is relevant to me ',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 26,
        label: 'Caters to me/my culture',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 27,
        label: 'Cares about my community ',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CONSUMER EXPERIENCE',
        rowType: 'h0'
      },
      {
        metric: 16,
        label: 'Is a good fit with this brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 19,
        label: 'Shows a place where I’d like to shop',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 20,
        label: 'Makes it easy to find what I am looking for',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 22,
        label: 'Provides excellent customer service',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CONSUMER PERCEPTIONS',
        rowType: 'h0'
      },
      {
        metric: 21,
        label: 'Carries high quality products',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 23,
        label: 'Has better prices than the competition',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 24,
        label: 'Carries a large variety of products',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 25,
        label: 'Carries unique products',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CUSTOM KPIs',
        rowType: 'h0'
      },
      {
         metric: 125,
        label: 'Makes me feel that H-E-B is part of your family’s life, not just a grocery store',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 126,
        label: 'Captures the unique spirit of Texas life',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 127,
        label: 'Portrays a family dynamic that feels real and relatable',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 128,
        label: 'Makes me feel proud to shop at a Texas-based brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 129,
        label: 'Makes me want to shop H-E-B over other grocery stores, even if it’s more difficult to get to',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: '',
        rowType: 'eol'
      }
    ]
  },
  "hispanic": {
    'audio': [
      {
        label: 'BREAKTHROUGH & BRANDING',
        rowType: 'h0'
      },
      {
        metric: 1,
        label: 'Total Ad Awareness',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 2,
        label: 'Brand Linkage (based to those aware)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 3,
        label: 'Branded Ad Awareness',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 5,
        label: 'Brand Uniqueness',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'AD REACTION',
        rowType: 'h0'
      },
      {
        metric: 6,
        label: 'Ad Appeal (Ad Likes)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 28,
        label: 'Ad Dislikes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'BRAND OUTCOMES',
        rowType: 'h0'
      },
      {
        metric: 121,
        label: 'Lift to Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 122,
        label: 'Lift to Brand Impression',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'COGNITIVE CONNECTION',
        rowType: 'h0'
      },
      {
        metric: 7,
        label: "Is informative",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 8,
        label: "Tells me something new about the brand",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 10,
        label: 'Is credible coming from this brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'BRAND CONNECTION',
        rowType: 'h0'
      },
      {
        metric: 9,
        label: 'Makes me feel closer to the brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 12,
        label: 'Portrays a brand I want to be associated with',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
      },
      {
        metric: 18,
        label: 'Fulfills my needs',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'ENGAGEMENT',
        rowType: 'h0'
      },
      {
        metric: 14,
        label: 'Is humorous',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 15,
        label: 'Is worth talking about',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 17,
        label: 'Is memorable',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 123,
        label: 'Is attention-getting',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 124,
        label: 'Connects with me emotionally',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'RELEVANCE',
        rowType: 'h0'
      },
      {
        metric: 11,
        label: 'Speaks directly to me',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 13,
        label: 'Is relevant to me ',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 26,
        label: 'Caters to me/my culture',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 27,
        label: 'Cares about my community ',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CONSUMER EXPERIENCE',
        rowType: 'h0'
      },
      {
        metric: 16,
        label: 'Is a good fit with this brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 19,
        label: 'Shows a place where I’d like to shop',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 20,
        label: 'Makes it easy to find what I am looking for',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 22,
        label: 'Provides excellent customer service',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CONSUMER PERCEPTIONS',
        rowType: 'h0'
      },
      {
        metric: 21,
        label: 'Carries high quality products',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 23,
        label: 'Has better prices than the competition',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 24,
        label: 'Carries a large variety of products',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 25,
        label: 'Carries unique products',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CUSTOM KPIs',
        rowType: 'h0'
      },
      {
         metric: 125,
        label: 'Makes me feel that H-E-B is part of your family’s life, not just a grocery store',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 126,
        label: 'Captures the unique spirit of Texas life',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 127,
        label: 'Portrays a family dynamic that feels real and relatable',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 128,
        label: 'Makes me feel proud to shop at a Texas-based brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 129,
        label: 'Makes me want to shop H-E-B over other grocery stores, even if it’s more difficult to get to',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: '',
        rowType: 'eol'
      }
    ],
    '***': [
      {
        label: 'BREAKTHROUGH & BRANDING',
        rowType: 'h0'
      },
      {
        metric: 1,
        label: 'Total Ad Awareness',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 2,
        label: 'Brand Linkage (based to those aware)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 3,
        label: 'Branded Ad Awareness',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 4,
        label: 'Ease of Brand Identification ',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 5,
        label: 'Brand Uniqueness',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'AD REACTION',
        rowType: 'h0'
      },
      {
        metric: 6,
        label: 'Ad Appeal (Ad Likes)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 28,
        label: 'Ad Dislikes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'BRAND OUTCOMES',
        rowType: 'h0'
      },
      {
        metric: 121,
        label: 'Lift to Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 122,
        label: 'Lift to Brand Impression',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'COGNITIVE CONNECTION',
        rowType: 'h0'
      },
      {
        metric: 7,
        label: "Is informative",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 8,
        label: "Tells me something new about the brand",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 10,
        label: 'Is credible coming from this brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'BRAND CONNECTION',
        rowType: 'h0'
      },
      {
        metric: 9,
        label: 'Makes me feel closer to the brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 12,
        label: 'Portrays a brand I want to be associated with',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
      },
      {
        metric: 18,
        label: 'Fulfills my needs',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'ENGAGEMENT',
        rowType: 'h0'
      },
      {
        metric: 14,
        label: 'Is humorous',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 15,
        label: 'Is worth talking about',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 17,
        label: 'Is memorable',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 123,
        label: 'Is attention-getting',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 124,
        label: 'Connects with me emotionally',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'RELEVANCE',
        rowType: 'h0'
      },
      {
        metric: 11,
        label: 'Speaks directly to me',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 13,
        label: 'Is relevant to me ',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 26,
        label: 'Caters to me/my culture',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 27,
        label: 'Cares about my community ',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CONSUMER EXPERIENCE',
        rowType: 'h0'
      },
      {
        metric: 16,
        label: 'Is a good fit with this brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 19,
        label: 'Shows a place where I’d like to shop',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 20,
        label: 'Makes it easy to find what I am looking for',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 22,
        label: 'Provides excellent customer service',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CONSUMER PERCEPTIONS',
        rowType: 'h0'
      },
      {
        metric: 21,
        label: 'Carries high quality products',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 23,
        label: 'Has better prices than the competition',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 24,
        label: 'Carries a large variety of products',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 25,
        label: 'Carries unique products',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CUSTOM KPIs',
        rowType: 'h0'
      },
      {
         metric: 125,
        label: 'Makes me feel that H-E-B is part of your family’s life, not just a grocery store',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 126,
        label: 'Captures the unique spirit of Texas life',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 127,
        label: 'Portrays a family dynamic that feels real and relatable',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 128,
        label: 'Makes me feel proud to shop at a Texas-based brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 129,
        label: 'Makes me want to shop H-E-B over other grocery stores, even if it’s more difficult to get to',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: '',
        rowType: 'eol'
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/app/configuration/HEB/config/components/scorecard/MetricsLabels/metricsLabels.js